import React, { SVGProps } from 'react'
const SvgSlashCircle = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="#D5404A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="m5.521 5.521 8.958 8.958M16.335 10a6.335 6.335 0 1 1-12.67 0 6.335 6.335 0 0 1 12.67 0Z"
    />
  </svg>
)
export default SvgSlashCircle
